import { makeStyles } from "@material-ui/core/styles";

export default makeStyles((theme) => ({
  warpperUnitsModelsCrad: {
    width: "415.33px",
    padding: "24px",
    gap: "16px",
    display: "flex",
    flexDirection: "column",
    [theme.breakpoints.down("md")]: {
      width: "100%",
    },
  },
  headerCard: {
    display: "flex",
    flexDirection: "column",
  },
  divider: {
    marginTop: "20px",
  },
  detailsUnits: {
    display: "flex",
    flexDirection: "row",
    gap: "8px",
  },
  containerUnitItem: {
    display: "flex",
    flexDirection: "row",
    gap: "4px",
  },
  dataContainer: {
    display: "flex",
    flexDirection: "row",
    gap: "16px",
  },
}));
